export default "__VITE_ASSET__DAj2Nec$__"